// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__37bYw","myModalContent":"MyModal_myModalContent__4mwmG","active":"MyModal_active__znG56"};